import React from "react"
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
`

const Name = styled.p`
  padding-top: 2.4rem;
  font-weight: 700;
`

const Job = styled.p`
  font-size: 1.1rem;
  font-weight: 500;
`

const Thumb = styled.div`
  ${({ theme: { color }}) => css`
    min-width: 80px;
    min-height: 80px;
    // border: solid 1px ${color.black};
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      // border-radius: 20px;
    }
  `}
`

const Guest = props => {

  const { thumb, name, job } = props.stats
  return (
    <Wrapper>
      <Thumb><img src={thumb} alt={name} /></Thumb>
      <Name>{name}</Name>
      <Job>{job}</Job>
    </Wrapper>
  )
}

export default Guest